import { TabList } from '@mui/lab';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(TabList)`
  flex-grow: 0 !important;
`;
